import { useState, useEffect } from 'react';
import * as Store from '@apply/store';
import { Question, QuestionType, PageQuestionProps, buildTypes, buildTypeString } from '@apply/ui';
import { connect } from 'react-redux';

const SiteBuiltOrManufacturedRental: React.FC<PageQuestionProps> = ({
    onQuestionValidate,
    submitted,
    property,
    onChange,
    required,
}) => {
    const [buildTypeSelectList, setBuildTypeSelectList] = useState<{ value: string; display: string }[]>();

    useEffect(() => {
        const tempBuildTypeList = [
            { display: '', value: '' },
            {
                display: buildTypeString(buildTypes.SiteBuilt),
                value: buildTypes.SiteBuilt.toString(),
            },
            {
                display: buildTypeString(buildTypes.Manufactured),
                value: buildTypes.Manufactured.toString(),
            },
        ];

        setBuildTypeSelectList(tempBuildTypeList);
    }, [property?.address?.state]);

    return (
        <div className='form-group'>
            <div className='row'>
                <Question
                    type={QuestionType.RowSelect}
                    submitted={submitted}
                    selector='buildType'
                    styleName='ungrouped'
                    onQuestionValidate={onQuestionValidate}
                    values={buildTypeSelectList}
                    value={property.rental?.buildType?.toString()}
                    onChange={(e) => {
                        onChange(property.guid, e);
                    }}
                    required={required}
                >
                    Is it a Site Built or Manufactured home?
                </Question>
            </div>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: {
        onChange: (guid: string, value: number) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChange: (guid: string, value: number) => {
            dispatch(Store.PropertiesStore.Actions.updateRentalBuildType(guid, value));
        },
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteBuiltOrManufacturedRental);
